import { Typography } from '@mui/material';
import { useContext } from 'react';

import { LocaleContext } from '@/Contexts/LocaleContext';
import { ProgramNames } from '@/models/Program';

import RowWrap from './IntakeRowWrap';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';
import { UsersContext } from '@/Contexts/UsersContext';

const NewPartnerSectionHeader = () => {
  const { translatedText } = useContext(LocaleContext);
  const { selectedProgramInfo } = useContext(PartnerIntakeContext);
  const { userCurrent } = useContext(UsersContext);

  return (
    <>
      <Typography style={{ marginTop: '0px', marginBottom: '10px' }} variant='h3'>
        {selectedProgramInfo.id === ProgramNames.TreeCitiesWorld
          ? translatedText.signup.headerPartnerDetails
          : `New ${selectedProgramInfo?.partnerTerm} Details`}
      </Typography>
      {userCurrent?.partnerGroupId == null && (
        <RowWrap>
          <Typography>{translatedText.signup.subHeaderPartnerDetails}</Typography>
        </RowWrap>
      )}
    </>
  );
};

export default NewPartnerSectionHeader;
